<div class="dialog-title" *ngIf="type=='create'">New Team</div>
<div class="dialog-title" *ngIf="type=='edit'">Edit Team</div>

<mat-form-field>
  <input matInput placeholder="Team Name" [(ngModel)]="teamName" required />
  <mat-error>Team Name is required </mat-error>
</mat-form-field>

<div class="dialog-buttons">
  <button mat-button color="primary" type="reset" [mat-dialog-close]="false">Cancel</button>
  <button mat-button color="primary" (click)="save()">Save</button>
</div>